import { useEffect, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router'
import { errorMessage, post } from '../api'
import { pendingInvite, useAuth } from '../auth'
import { Alert, Spinner } from '../components/ui'

/**
 * Landing page for an invitation link. Signed-out people are sent to sign in (the token waits
 * in session storage); signed-in people accept straight away.
 */
export function InvitePage() {
  const { me, loading, refresh } = useAuth()
  const [params] = useSearchParams()
  const token = params.get('token')
  const [result, setResult] = useState<{ businessId: string } | { error: string } | null>(null)

  useEffect(() => {
    if (!token) return
    if (!me) {
      pendingInvite.set(token)
      return
    }
    post<{ businessId: string; role: string }>('/v1/auth/invites/accept', { token })
      .then(async (r) => {
        pendingInvite.clear()
        await refresh()
        setResult({ businessId: r.businessId })
      })
      .catch((err) => setResult({ error: errorMessage(err) }))
  }, [token, me, refresh])

  if (!token) return <Navigate to="/" replace />
  if (loading) return <Spinner />
  if (!me) return <Navigate to="/sign-in" replace />
  if (result && 'businessId' in result) return <Navigate to={`/b/${result.businessId}/today`} replace />
  return (
    <div className="auth-page">
      <div className="auth-card">{result && 'error' in result ? <Alert>{result.error}</Alert> : <Spinner label="Accepting invitation" />}</div>
    </div>
  )
}
